export const _setIsUserLocation = (state, action) => {
  state.isUserLocation = action.payload;
};
